/**
 *
 *
 */

const HEADLINE_SLOT_NAME = "headline";

const CONTENT_SELECTORS = {
  HEADLINE_SLOT: `[slot="${HEADLINE_SLOT_NAME}"]`,
  HEADLINE: `[data-title]`,
};

function hasHeadlineSlot(content: DocumentFragment): boolean {
  return !!content.querySelector(CONTENT_SELECTORS.HEADLINE_SLOT);
}

/**
 *
 *
 *
 */
function parseHeadline(content: DocumentFragment): DocumentFragment {
  /*                                                           */
  if (!hasHeadlineSlot(content)) {
    const headlineElement = content.querySelector(CONTENT_SELECTORS.HEADLINE);
    const headline = headlineElement?.getAttribute("data-title");
    if (headline) {
      const template = document.createElement("template");
      template.innerHTML = `<h3 class="oc-headline-100" slot="${HEADLINE_SLOT_NAME}">${headline}</h3>`;
      content.append(template.content);
    }
  }
  return content;
}

/**
 *
 *
 */
function parseLegacyContent(content: DocumentFragment): DocumentFragment {
  const parsedContent = parseHeadline(content);
  return parsedContent;
}

export { parseLegacyContent };
